import defaultSettings from '@/settings';

const title = defaultSettings.title || '医推摩盘';

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    // return `${pageTitle} - ${title}`
    return `${pageTitle}`;
  }
  return `${title}`;
}
